<template>
  <div class="mobile_login">
    <!-- 登录 -->
    <div class="mobile_login_content">
      <h2>hecoos</h2>
      <form action="">
        <input v-model="postData.loginName" type="text" placeholder="Account/E-mail">
        <input v-model="postData.password" type="password" placeholder="Enter your password">
        <button :disabled="!isButtonEnabled" type="submit" @click="handleSubmit">Login</button>
      </form>
      <p>
        <!-- <span @click="jumpTo('/en')">Back to the home page</span>丨 -->
        <span @click="jumpTo('/en/Register')">Register</span>丨<span
          @click="jumpTo('/en/forget_password')">Forgot the password?</span>
      </p>
    </div>
  </div>
</template>
<script>
import { adminLogin } from "@/api/api"
import { Message } from "element-ui";
import store from "@/store";
export default {
  name: "mobile_login",
  data() {
    return {
      postData: {
        loginName: "",
        password: "",
      },
    }
  },
  computed: {
    isButtonEnabled() {
      return this.postData.password.length >= 6 && !this.loginName;
    },
  },
  methods: {
    jumpTo(url) {
      // console.log(url);
      this.$router.push(url)
    },
    // 登录
    handleSubmit() {
      adminLogin(this.postData).then(res => {
        // console.log(res);
        if (res.code === 200) {
          Message.success(res.message);
          res.data.work_duration = parseInt(res.data.work_duration)
          if (res.data.work_duration > 1) {
            res.data.work_duration = res.data.work_duration + ' years'
          } else {
            res.data.work_duration = res.data.work_duration + ' year'
          }
          store.dispatch("saveAdminUserInfo", res.data);
          localStorage.setItem("token", JSON.stringify(res.data.token));
          // setTimeout(() => {
          //   this.$router.push("/en/personalCenter");
          // }, 1000);
          if (localStorage.getItem('orderMsg')) {
            this.$router.push("/en/SoftwareSubscriptions");
          } else {
            setTimeout(() => {
              this.$router.push("/en/personalCenter");
            }, 1000);
          }
        } else {
          Message.error(res.message);
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.mobile_login {
  width: 100%;
  height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-19/b946e97c082f040312c95a399d847c29.png");
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  // background-color: #d0cad4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;

  .mobile_login_content {
    width: 100%;
    max-width: 370px;
    background-color: #222222;
    padding: 20px;
    border-radius: 6px;
    text-align: center;

    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // gap: 10px;
    h2 {
      font-size: 24px;
      color: #fff;
      margin-bottom: 15px;
    }

    input {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 12px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #757575;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    button {
      display: block;
      width: 100%;
      font-size: 18px;
      margin-top: 15px;
      padding: 8px;
      border: none;
      border-radius: 6px;
    }

    p {
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
</style>
